<template>
  <el-row class="c-search">
    <el-form
      size="small"
      :model="value"
      ref="cSearch"
      :label-width="labelWidth"
      @submit.native.prevent
    >
      <div class="form-container">
        <div class="search-container">
          <slot>
            <c-search-item :searchItems="searchItems" ref="cSearchItem" />
          </slot>
        </div>
        <div class="opt-container">
          <el-form-item label-width="0">
            <div class="opt-group">
              <span @click="search" class="opt-btn" title="搜索">
                <i class="iconfont icon-chazhaosousuo"></i>
              </span>
              <span @click="reset" class="opt-btn" title="重置">
                <i class="iconfont icon-reset"></i>
              </span>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </el-row>
</template>

<script>
import CSearchItem from "./src/CSearchItem";

export default {
  props: {
    span: {
      type: Number,
      default: 8,
    },
    labelWidth: {
      type: String,
      default: "80px",
    },
    value: Object,
    searchItems: Array,
  },
  components: {
    CSearchItem,
  },
  provide() {
    return {
      cSearch: this,
    };
  },
  methods: {
    search() {
      this.$emit("search");
    },
    reset() {
      this.$emit("reset");
    },
  },
};
</script>

<style lang="less">
.c-search {
  .operation-btn {
    width: 70%;
    height: 32px;
    margin-bottom: 18px;
  }
  .operation-btn-reset {
    border: 1px solid #197ce9;
    color: #197ce9;
    margin-left: 0;
    &.btn-inline {
      margin-left: 10px;
    }
  }
  .btn-inline {
    width: 40%;
  }
}

.form-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .search-container {
    width: calc(100% - 100px);
  }
  .opt-container {
    width: 100px;
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 10px !important;
    }
  }
}
.btn-inline-ss {
  padding-left: 11px;
}
.opt-group {
  display: flex;
  align-items: center;
  padding-left: 10px;
  // justify-content: space-around;
  .opt-btn {
    cursor: pointer;
    margin: 0 5px;
    i {
      font-size: 30px;
      color: #febc8e;
      vertical-align: middle;
    }
  }
}
</style>
